import { useEffect } from 'react';

const setMeta = (attr, key, content) => {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const setCanonical = (href) => {
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', href);
};

const OG_LOCALES = { fr: 'fr_LU', de: 'de_LU', en: 'en_GB' };

// Balises hreflang : une par langue, plus x-default vers le français.
const setAlternates = (alternates) => {
  document.querySelectorAll('link[rel="alternate"][hreflang]').forEach((el) => el.remove());
  if (!alternates) return;
  const entries = [...Object.entries(alternates), ['x-default', alternates.fr]];
  for (const [lang, href] of entries) {
    const link = document.createElement('link');
    link.setAttribute('rel', 'alternate');
    link.setAttribute('hreflang', lang);
    link.setAttribute('href', `https://www.expomis.com${href}`);
    document.head.appendChild(link);
  }
};

export default function useSEO({ title, description, path, noindex = false, lang = 'fr', alternates = null }) {
  useEffect(() => {
    document.documentElement.lang = lang;
    setMeta('property', 'og:locale', OG_LOCALES[lang]);
    setAlternates(alternates);
    if (title) document.title = title;
    if (description) {
      setMeta('name', 'description', description);
      setMeta('property', 'og:description', description);
    }
    if (title) setMeta('property', 'og:title', title);
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:url', `https://www.expomis.com${path || ''}`);
    setCanonical(`https://www.expomis.com${path || ''}`);
    setMeta('name', 'robots', noindex ? 'noindex' : 'index, follow');
  }, [title, description, path, noindex, lang, alternates]);
}
